export const categoryContent: Record<string, Array<{
  id: string;
  title: string;
  excerpt: string;
  content: string;
  imageUrl: string;
  date: string;
  duration: string;
  views: number;
  tags: string[];
}>> = {
  'japan-korea': [
    {
      id: 'jk-1',
      title: '《首尔大作战》电影深度解析：动作与喜剧的完美融合',
      excerpt: '这部2026年暑期档最受关注的韩国动作喜剧电影，不仅有着精彩的追车场面，更展现了韩国电影工业的成熟叙事能力。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Korean%20action%20film%20photography%20with%20dynamic%20car%20chase%20scene%2C%20neon%20lit%20Seoul%20night%20streets%2C%20dramatic%20lighting%2C%20rich%20amber%20and%20cool%20contrast%20tones&width=1200&height=600&seq=cat-jk-01&orientation=landscape',
      date: '2026-08-11',
      duration: '45:20',
      views: 156000,
      tags: ['韩国电影', '动作', '喜剧'],
    },
    {
      id: 'jk-2',
      title: '走进京都：10部不可错过的日本时代剧',
      excerpt: '从武士道精神到江户风情，日本时代剧以其独特的文化美学吸引着全球观众。我们精选了十部最具代表性的作品。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Japanese%20period%20drama%20photography%20with%20samurai%20in%20traditional%20Kyoto%20setting%2C%20cherry%20blossoms%2C%20soft%20natural%20lighting%2C%20rich%20amber%20and%20crimson%20tones&width=1200&height=600&seq=cat-jk-02&orientation=landscape',
      date: '2026-08-09',
      duration: '38:15',
      views: 112000,
      tags: ['日本时代剧', '武士', '京都'],
    },
    {
      id: 'jk-3',
      title: 'K-Pop幕后全纪录：一支MV的诞生',
      excerpt: '从概念设计到最终成品，这部纪录片完整记录了一支K-Pop MV的制作全过程，揭开偶像工业的神秘面纱。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20K-Pop%20music%20video%20production%20photography%20with%20colorful%20stage%20lighting%2C%20dance%20studio%20atmosphere%2C%20dynamic%20composition%2C%20rich%20vibrant%20amber%20and%20bright%20accent%20colors&width=1200&height=600&seq=cat-jk-03&orientation=landscape',
      date: '2026-08-07',
      duration: '52:30',
      views: 198000,
      tags: ['K-Pop', '幕后', 'MV制作'],
    },
    {
      id: 'jk-4',
      title: '治愈系日剧推荐：在平凡生活中寻找温暖',
      excerpt: '日剧独特的治愈风格让人在快节奏生活中找到片刻宁静。这些作品用细腻的笔触描绘了寻常日子中的不寻常感动。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Japanese%20slice%20of%20life%20drama%20photography%20with%20cozy%20interior%20cafe%20scene%2C%20soft%20natural%20morning%20lighting%2C%20gentle%20composition%2C%20rich%20amber%20and%20cream%20tones&width=1200&height=600&seq=cat-jk-04&orientation=landscape',
      date: '2026-08-05',
      duration: '28:45',
      views: 87000,
      tags: ['日剧', '治愈', '生活'],
    },
  ],
  'chinese': [
    {
      id: 'cn-1',
      title: '《长安十二时辰》续作来了！马伯庸新剧《两京十五日》独家探班',
      excerpt: '继《长安十二时辰》后，马伯庸又一部历史悬疑小说被搬上荧幕。我们深入片场，独家揭秘这部备受期待的华语大剧。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Chinese%20historical%20drama%20film%20set%20photography%20with%20ancient%20costumes%2C%20elaborate%20set%20design%2C%20dramatic%20lighting%2C%20rich%20golden%20amber%20and%20deep%20red%20tones&width=1200&height=600&seq=cat-cn-01&orientation=landscape',
      date: '2026-08-10',
      duration: '35:10',
      views: 234000,
      tags: ['华语剧集', '历史悬疑', '马伯庸'],
    },
    {
      id: 'cn-2',
      title: '台湾新电影浪潮：五位不可忽视的华语导演',
      excerpt: '从侯孝贤到新一代创作者，台湾电影以其独特的人文视角持续影响着华语电影的发展。我们聚焦五位正在改变行业格局的导演。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Taiwanese%20art%20film%20photography%20with%20urban%20Taipei%20night%20scene%2C%20rain%20slicked%20streets%2C%20moody%20atmosphere%2C%20rich%20amber%20and%20teal%20contrast%20tones&width=1200&height=600&seq=cat-cn-02&orientation=landscape',
      date: '2026-08-08',
      duration: '42:00',
      views: 98000,
      tags: ['台湾电影', '导演', '华语电影'],
    },
    {
      id: 'cn-3',
      title: '香港功夫片的前世今生：从李小龙到甄子丹',
      excerpt: '功夫片是华语电影对世界电影最重要的贡献之一。这部纪录片追溯了香港功夫片半个多世纪的辉煌历程。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Hong%20Kong%20martial%20arts%20film%20photography%20with%20dynamic%20action%20pose%2C%20classic%20movie%20poster%20aesthetic%2C%20dramatic%20lighting%2C%20rich%20amber%20and%20deep%20shadow%20tones&width=1200&height=600&seq=cat-cn-03&orientation=landscape',
      date: '2026-08-06',
      duration: '55:20',
      views: 167000,
      tags: ['功夫片', '香港电影', '动作'],
    },
    {
      id: 'cn-4',
      title: '中国纪录片《人间烟火》：小城故事的温柔力量',
      excerpt: '离开大城市的喧嚣，这部纪录片将镜头对准了中国各地的普通小城，记录了那些被忽略的温暖日常和人间百态。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Chinese%20small%20town%20documentary%20photography%20with%20local%20street%20market%20scene%2C%20golden%20hour%20natural%20lighting%2C%20intimate%20candid%20composition%2C%20rich%20amber%20and%20earthy%20tones&width=1200&height=600&seq=cat-cn-04&orientation=landscape',
      date: '2026-08-04',
      duration: '48:30',
      views: 123000,
      tags: ['纪录片', '小城故事', '人文'],
    },
  ],
  'southeast-asia': [
    {
      id: 'sea-1',
      title: '泰国恐怖片的独特魅力：为何能征服全球观众',
      excerpt: '泰国恐怖片以其浓厚的本土文化和精妙的叙事结构，在亚洲乃至全球恐怖片领域占据独特地位。我们探究其成功背后的文化密码。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Thai%20horror%20film%20photography%20with%20traditional%20temple%20setting%2C%20eerie%20atmospheric%20lighting%2C%20moody%20shadows%2C%20rich%20amber%20and%20dark%20crimson%20tones&width=1200&height=600&seq=cat-sea-01&orientation=landscape',
      date: '2026-08-10',
      duration: '30:45',
      views: 142000,
      tags: ['泰国恐怖片', '东南亚电影', '文化'],
    },
    {
      id: 'sea-2',
      title: '越南独立导演阮芳英：用镜头讲述湄公河故事',
      excerpt: '作为东南亚独立电影界最受关注的新锐导演，阮芳英的作品以诗意的画面和深刻的人文关怀打动了国际观众。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Vietnamese%20Mekong%20river%20documentary%20photography%20with%20floating%20market%20scene%2C%20golden%20sunset%20lighting%2C%20poetic%20composition%2C%20rich%20amber%20and%20emerald%20green%20tones&width=1200&height=600&seq=cat-sea-02&orientation=landscape',
      date: '2026-08-08',
      duration: '26:30',
      views: 76000,
      tags: ['越南电影', '独立导演', '湄公河'],
    },
    {
      id: 'sea-3',
      title: '印尼网剧崛起：东南亚数字内容新势力',
      excerpt: '随着互联网普及率提升，印尼网剧产业正在经历爆发式增长。一批本土创作者通过数字平台将印尼故事带给世界。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Indonesian%20web%20series%20production%20photography%20with%20modern%20Jakarta%20urban%20scene%2C%20digital%20creative%20studio%20atmosphere%2C%20rich%20amber%20and%20tropical%20green%20tones&width=1200&height=600&seq=cat-sea-03&orientation=landscape',
      date: '2026-08-06',
      duration: '22:15',
      views: 58000,
      tags: ['印尼网剧', '数字内容', '东南亚'],
    },
  ],
  'variety': [
    {
      id: 'var-1',
      title: '《亚洲达人秀》最新季：令人惊艳的舞台奇迹',
      excerpt: '新一季《亚洲达人秀》汇集了来自12个国家的顶尖才艺表演者，从杂技到魔术，每一个舞台都令人叹为观止。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20talent%20show%20stage%20photography%20with%20dramatic%20spotlight%20and%20confetti%2C%20grand%20auditorium%20atmosphere%2C%20dynamic%20performance%20composition%2C%20rich%20golden%20amber%20and%20vibrant%20accent%20colors&width=1200&height=600&seq=cat-var-01&orientation=landscape',
      date: '2026-08-10',
      duration: '60:00',
      views: 312000,
      tags: ['综艺', '达人秀', '才艺'],
    },
    {
      id: 'var-2',
      title: '日本搞笑综艺为什么这么上头？笑点背后的文化逻辑',
      excerpt: '从《不能笑》系列到各类整蛊节目，日本搞笑综艺在全球拥有大量粉丝。我们解析其独特的幽默机制和文化内涵。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Japanese%20comedy%20variety%20show%20photography%20with%20colorful%20studio%20set%2C%20comedians%20on%20stage%2C%20vibrant%20lighting%2C%20rich%20amber%20and%20bright%20neon%20accent%20colors&width=1200&height=600&seq=cat-var-02&orientation=landscape',
      date: '2026-08-08',
      duration: '35:20',
      views: 189000,
      tags: ['日本综艺', '搞笑', '文化解析'],
    },
    {
      id: 'var-3',
      title: '韩国真人秀恋爱综艺：《Heart Signal》新季解析',
      excerpt: '韩国恋爱真人秀持续火爆，《Heart Signal》以细腻的情感捕捉和精妙的剪辑成为现象级综艺。新一季又有哪些看点？',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Korean%20dating%20reality%20show%20photography%20with%20romantic%20dinner%20setting%2C%20soft%20candlelight%20atmosphere%2C%20intimate%20composition%2C%20rich%20amber%20and%20rose%20gold%20tones&width=1200&height=600&seq=cat-var-03&orientation=landscape',
      date: '2026-08-06',
      duration: '40:10',
      views: 245000,
      tags: ['韩国综艺', '恋爱真人秀', 'Heart Signal'],
    },
  ],
  'documentary': [
    {
      id: 'doc-1',
      title: '《喜马拉雅》：极限摄影师带你攀登世界之巅',
      excerpt: '这部令人窒息的纪录片跟随一位极限摄影师，记录了他攀登珠穆朗玛峰的全过程。每一帧画面都是对生命和自然的崇高致敬。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Himalayan%20mountain%20documentary%20photography%20with%20snow%20capped%20peaks%2C%20dramatic%20alpine%20glow%20lighting%2C%20epic%20wide%20composition%2C%20rich%20golden%20amber%20and%20crisp%20white%20contrast&width=1200&height=600&seq=cat-doc-01&orientation=landscape',
      date: '2026-08-10',
      duration: '65:00',
      views: 178000,
      tags: ['纪录片', '极限运动', '喜马拉雅'],
    },
    {
      id: 'doc-2',
      title: '日本茶道：一杯茶中的千年美学',
      excerpt: '这部精美的纪录片深入日本茶道世界，从茶叶种植到茶室礼仪，完整呈现了这一传统文化的精神内涵和美学追求。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20Japanese%20tea%20ceremony%20documentary%20photography%20with%20traditional%20tea%20room%20setting%2C%20soft%20tatami%20mat%20lighting%2C%20serene%20composition%2C%20rich%20amber%20and%20matcha%20green%20tones&width=1200&height=600&seq=cat-doc-02&orientation=landscape',
      date: '2026-08-08',
      duration: '32:40',
      views: 95000,
      tags: ['纪录片', '日本文化', '茶道'],
    },
    {
      id: 'doc-3',
      title: '东南亚珊瑚礁：海底世界的最后净土',
      excerpt: '海洋生物学家带领团队深入东南亚海域，记录下全球最丰富的珊瑚礁生态系统，同时警示气候变化带来的严峻威胁。',
      content: '',
      imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20underwater%20coral%20reef%20documentary%20photography%20with%20vibrant%20marine%20life%2C%20sunlight%20filtering%20through%20water%2C%20rich%20amber%20and%20turquoise%20blue%20contrast%20tones&width=1200&height=600&seq=cat-doc-03&orientation=landscape',
      date: '2026-08-06',
      duration: '45:30',
      views: 132000,
      tags: ['纪录片', '海洋', '环保'],
    },
  ],
};

export const categoryMeta: Record<string, {
  name: string;
  description: string;
  keywords: string;
  breadcrumb: string;
}> = {
  'japan-korea': {
    name: '日韩专区',
    description: '日韩视频精选——最新日剧、韩剧、动漫、J-Pop、K-Pop等日韩精品内容，高清流畅在线观看。',
    keywords: '日韩视频,日剧在线观看,韩剧在线观看,日本动漫,K-Pop视频,J-Pop视频',
    breadcrumb: '日韩专区',
  },
  'chinese': {
    name: '华语精选',
    description: '华语视频精选——华语电影、电视剧、纪录片、综艺等优质内容聚合，发现最新最热华语视频资源。',
    keywords: '华语视频,华语电影在线观看,华语电视剧,中国纪录片,台湾电影,香港电影',
    breadcrumb: '华语精选',
  },
  'southeast-asia': {
    name: '东南亚',
    description: '东南亚视频精选——泰国、越南、印尼、新加坡等东南亚地区精彩视频内容，探索多元文化魅力。',
    keywords: '东南亚视频,泰国电影,越南电影,印尼视频,新加坡视频,东南亚内容',
    breadcrumb: '东南亚',
  },
  'variety': {
    name: '综艺娱乐',
    description: '亚洲综艺娱乐精选——日韩华语东南亚各地热门综艺节目、真人秀、脱口秀等，精彩不断。',
    keywords: '亚洲综艺,日韩综艺,华语综艺,真人秀,脱口秀,娱乐节目',
    breadcrumb: '综艺娱乐',
  },
  'documentary': {
    name: '纪录短片',
    description: '亚洲纪录短片精选——深度纪录片、人文纪实、自然探索等优质内容，用镜头记录真实亚洲。',
    keywords: '亚洲纪录片,纪录短片,人文纪实,自然探索,深度纪录片',
    breadcrumb: '纪录短片',
  },
};